import styled from 'styled-components';
import { Icon } from 'ui-kit';

export const StyledIcon = styled(Icon)`
    fill: ${({ isActive, theme }) => (isActive ? theme.colors.MAIN : '')};
    stroke: ${({ isActive, theme }) => (isActive ? theme.colors.MAIN : '')};
`;

export const SidebarWrapper = styled.div`
  position: relative;
  width: 60px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const Sidebar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.MODAL_SIDEBAR};
  overflow: hidden;
  transition: all 0.15s cubic-bezier(0.84, 0.02, 0.37, 0.74);
  &:hover {
    width: 240px;
    }
  }
`;

export const SidebarItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  padding: 20px;
  cursor: pointer;
  box-shadow: ${({ isActive }) => (isActive ? '0px 0px 5px 1px rgb(112 112 112 / 50%)' : 'none')};
  color: ${({ isActive, theme }) => (isActive ? theme.colors.MAIN : theme.colors.BLACK)};
  &:hover {
    color: ${({ theme }) => theme.colors.MAIN};
  }
`;

export const TextBlock = styled.div`
  width: 75%;
  text-align: left;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  box-sizing: border-box;
  width: calc(100% - 60px);
  height: 100%;
  padding: 10px;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 67%;
`;

export const FileItem = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
`;

export const FileImage = styled.img`
  height: 50px;
  object-fit: contain;
`;

export const FileInfoBlock = styled.div`
  height: 50px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const FileName = styled.span`
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
`;

export const FileSize = styled.span`
  font-size: 12px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.DRAG_DROP_TEXT};
`;

export const IconButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  :hover ${StyledIcon} {
     opacity: 0.7;
   }
`;
